import React from 'react'
import Link from 'next/link'
import qs from "querystring";

interface PageNavigationProps {
  page: number;
  totalPages: number;
}

export default function PageNavigation({ page, totalPages }: PageNavigationProps) {
  // console.log('PageNavigation', page, totalPages)
  const btnQueries = React.useMemo(() => {
    let query: qs.ParsedUrlQuery = {};
    if (window.location.search) {
      query = qs.parse(window.location.search.substring(1));
    }

    const nextPage = {
      ...query,
      page: (page + 1).toString()
    };
    const prevPage = {
      ...query,
      page: (page - 1).toString()
    };
    const totalPage = {
      ...query,
      page: totalPages.toString()
    };
    const firstPage = {
      ...query,
      page: '1'
    };

    return {
      nextPage: qs.stringify(nextPage),
      prevPage: qs.stringify(prevPage),
      totalPage: qs.stringify(totalPage),
      firstPage: qs.stringify(firstPage),
    };
  }, [window.location.search]);


  if (totalPages === 0) {
    return null;
  } else {
  	return (
      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center">
          {page === 1 ? (
            <li className="page-item disabled">
              <span className="page-link">Previous</span>
            </li>
          ) : (
            <>
              <li className="page-item">
                <Link
                  href={`${window.location.pathname}?${btnQueries.prevPage}`}
                  className="page-link">Previous</Link>
              </li>
              <li className="page-item">
                <Link href={`${window.location.pathname}?${btnQueries.firstPage}`} className="page-link">1</Link>
              </li>
            </>
          )}
          {page >= 3 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}
          <li className="page-item active">
            <span className="page-link">{page}</span>
          </li>
          {page < (totalPages - 1) && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}
          {totalPages === page ? (
            <li className="page-item disabled">
              <span className="page-link">Next</span>
            </li>
          ) : (
            <React.Fragment>
              <li className="page-item">
                <Link
                  className="page-link"
                  href={`${window.location.pathname}?${btnQueries.totalPage}`}
                >
                  {totalPages}
                </Link>
              </li>
              <li className="page-item">
                <Link className="page-link" href={`${window.location.pathname}?${btnQueries.nextPage}`}>Next</Link>
              </li>
            </React.Fragment>
          )}
        </ul>
      </nav>
    );
  }
}